var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddressEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 7.7207H6C5.46957 7.7207 4.96086 7.93142 4.58579 8.30649C4.21071 8.68156 4 9.19027 4 9.7207V18.7207C4 19.2511 4.21071 19.7598 4.58579 20.1349C4.96086 20.51 5.46957 20.7207 6 20.7207H15C15.5304 20.7207 16.0391 20.51 16.4142 20.1349C16.7893 19.7598 17 19.2511 17 18.7207V17.7207",
    stroke: "#4A78B9",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 5.72081L19 8.72081M20.385 7.30581C20.7788 6.91196 21.0001 6.37779 21.0001 5.82081C21.0001 5.26383 20.7788 4.72966 20.385 4.33581C19.9912 3.94196 19.457 3.7207 18.9 3.7207C18.343 3.7207 17.8088 3.94196 17.415 4.33581L9 12.7208V15.7208H12L20.385 7.30581Z",
    stroke: "#4A78B9",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddressEdit);
export default __webpack_public_path__ + "static/media/address-edit.99b3b265179940542c30c7fb9063cee7.svg";
export { ForwardRef as ReactComponent };